import * as React from 'react';
import { RouteComponentProps, StaticRouter } from 'react-router-dom';
import { PiralRoutes } from './PiralRoutes';
import { PiralError, PiralRouter, PiralLoadingIndicator, PiralLayout } from './components';
import { useGlobalState } from '../hooks';

const NotFound: React.FC<RouteComponentProps> = props => <PiralError type="not_found" {...props} />;

const PiralContent: React.FC = () => {
  const { error, loading, layout } = useGlobalState(m => m.app);

  return error ? (
    <PiralError type="loading" error={error} />
  ) : loading ? (
    <PiralLoadingIndicator />
  ) : (
    <PiralLayout currentLayout={layout}>
      <PiralRoutes NotFound={NotFound} />
    </PiralLayout>
  );
};

const Router = typeof window === 'undefined' ? props => <StaticRouter location="/" {...props} /> : PiralRouter;

const PiralProvider: React.FC = ({ children }) => {
  const provider = useGlobalState(m => m.provider) || <React.Fragment />;
  return React.cloneElement(provider, undefined, children);
};

export interface PiralViewProps {}

export const PiralView: React.FC<PiralViewProps> = ({ children }) => (
  <PiralProvider>
    <Router>
      <PiralContent />
      {children}
    </Router>
  </PiralProvider>
);
PiralView.displayName = 'PiralView';
